// Case data — MM Byggeri & Rådgivning
const IMG = {
    // Bengtasvej 6
    diningHall: "/images/diningHall",
    exterior: "/images/exterior",
    bathroomMirror: "/images/bathroomMirror",
    chandeliers: "/images/chandeliers",
    stairOverhead: "/images/stairOverhead",
    oakDoorsDusk1: "/images/oakDoorsDusk1",
    corridorSteel: "/images/corridorSteel",
    oakDoorsDusk2: "/images/oakDoorsDusk2",
    // Mixed / general detail (case attribution to be confirmed)
    wallpaperHallway: "/images/wallpaperHallway",
    spiralStair: "/images/spiralStair",
    sauna: "/images/sauna",
    brassTap: "/images/brassTap",
    // Kystvej 37B
    kystHall: "/images/kystHall",
    kystCoffered: "/images/kystCoffered",
    kystChevronFloor: "/images/kystChevronFloor",
    kystBrassShower: "/images/kystBrassShower",
    kystKitchenButler: "/images/kystKitchenButler",
    kystKitchenHoodDetail: "/images/kystKitchenHoodDetail",
    kystKitchenMain: "/images/kystKitchenMain",
    kystKitchenWide: "/images/kystKitchenWide",
    kystParquet: "/images/kystParquet",
    droneExterior: "/images/droneExterior",
    copperDetail: "/images/copperDetail",
    kystDrone2: "/images/kystDrone2",
    kystCedarCopper: "/images/kystCedarCopper",
    kystMarbleShower2: "/images/kystMarbleShower2",
    kystWallpaper: "/images/kystWallpaper",
    kystKitchenFull: "/images/kystKitchenFull",
    kystCorridor: "/images/kystCorridor",
    kyst2231: "/images/kyst2231",
    kyst2241: "/images/kyst2241",
    kyst2250: "/images/kyst2250",
    kyst2254: "/images/kyst2254",
    kyst2258: "/images/kyst2258",
};

export const heroImages = IMG;

export const cases = [
    {
        slug: "bengtasvej-6",
        type: "renovation",
        title: { da: "Bengtasvej", en: "Bengtasvej" },
        subtitle: {
            da: "Renovering af historisk ejendom til eksklusivt gæste- og festhus",
            en: "Renovation of a historic property into an exclusive guest and event house",
        },
        location: { da: "Hellerup", en: "Hellerup" },
        year: "2025",
        scope: { da: "305 m²  ·  Hovedentreprise", en: "305 m²  ·  General contract" },
        architect: "—",
        hero: IMG.chandeliers,
        body: {
            da: [
                "På Bengtasvej i Hellerup har MM Byggeri & Rådgivning stået for en gennemgribende renovering af en historisk ejendom fra slutningen af 1800-tallet. Projektet blev udført som hovedentreprise og omfattede transformationen af et opkøbt nabohus til et eksklusivt fest- og gæstehus med respekt for både arkitektur, materialer og eksisterende konstruktioner.",
                "Ejendommen rummer en lang række specialløsninger og materialevalg i højeste kvalitet. Blandt andet specialbyggede kviste i egetræ, skiffertag, linolievinduer, massive Dinesen-planker på 400 mm, italienske fliser, kalkmalede vægge samt specialudført gaspejs og vinrum.",
                "Flere af de eksisterende konstruktioner blev bevaret og integreret som en aktiv del af det arkitektoniske udtryk, herunder synlige egetræsbjælker i køkkenet og åbningen mellem stue og førstesal, hvor en del af etagedækket blev fjernet for at skabe mere rumlighed og lys.",
                "Projektet er et godt eksempel på den type renoveringer, hvor detaljeniveau, materialeforståelse og respekt for den oprindelige bygning er afgørende for det samlede resultat. Her handler det ikke kun om at bygge nyt, men om at skabe en helstøbt oplevelse, hvor arkitektur, håndværk og stemning hænger naturligt sammen.",
            ],
            en: [
                "On Bengtasvej in Hellerup, MM Byggeri & Rådgivning carried out a comprehensive renovation of a historic property from the late 1800s. Executed as a general contract, the project transformed an acquired neighbouring house into an exclusive guest and event house with respect for architecture, materials and existing structures.",
                "The property holds a long list of custom solutions and material choices of the highest quality — including bespoke oak dormers, slate roofing, linseed-oil windows, solid 400 mm Dinesen planks, Italian tiles, lime-painted walls and a custom-built gas fireplace and wine room.",
                "Several existing structures were preserved and integrated as an active part of the architectural expression — including visible oak beams in the kitchen and the opening between the living room and first floor, where part of the floor slab was removed to create more spatial flow and light.",
                "The project is a clear example of the type of renovation where attention to detail, material understanding and respect for the original building are decisive for the result. It is not only about building new, but about creating a coherent experience where architecture, craft and atmosphere belong naturally together.",
            ],
        },
        gallery: [
            IMG.diningHall,
            IMG.exterior,
            IMG.bathroomMirror,
            IMG.chandeliers,
            IMG.wallpaperHallway,
            IMG.oakDoorsDusk1,
            IMG.corridorSteel,
            IMG.oakDoorsDusk2,
            IMG.spiralStair,
            IMG.stairOverhead,
            IMG.sauna,
        ],
        materials: {
            da: [
                "Specialbyggede egetræs-kviste",
                "Skiffertag",
                "Linolievinduer",
                "Dinesen-planker 400 mm",
                "Italienske fliser",
                "Kalkmalede vægge",
                "Gaspejs & vinrum",
            ],
            en: [
                "Custom oak dormers",
                "Slate roofing",
                "Linseed-oil windows",
                "Dinesen planks, 400 mm",
                "Italian tiles",
                "Lime-painted walls",
                "Gas fireplace & wine room",
            ],
        },
    },
    {
        slug: "kystvej-37b",
        type: "summerhouse",
        title: { da: "Kystvej", en: "Kystvej" },
        subtitle: {
            da: "Eksklusivt sommerhus opført fra bunden på en af Danmarks mest attraktive adresser",
            en: "Exclusive summer house built from the ground up on one of Denmark's most attractive addresses",
        },
        location: { da: "Hornbæk", en: "Hornbæk" },
        year: "2025",
        scope: { da: "380 m²  ·  Hovedentreprise", en: "380 m²  ·  General contract" },
        architect: "—",
        hero: IMG.kyst2250,
        body: {
            da: [
                "På Kystvej i Hornbæk har MM Byggeri & Rådgivning opført et nyt sommerhus på 380 m² som hovedentreprise. Projektet er placeret på en af Danmarks mest eksklusive sommerhusveje og er skabt med kompromisløst fokus på materialer, detaljer og den samlede oplevelse af huset.",
                "Projektet omfattede blandt andet udgravning til fuld kælder under krævende forhold, hvor grundvand løbende skulle pumpes væk for at kunne etablere konstruktionen korrekt.",
                "Selve huset er opført som træhus og udført med en lang række eksklusive materialevalg, herunder canadiske rødcederspån, kobberdetaljer, naturstensgulve, italienske fliser, egetræsgulve i stor sildebensstav samt specialolierede overflader. Vinduer og døre er leveret af Skjern Vinduer, mens huset desuden er udstyret med integrerede skydedøre, specialtapeter og håndstrøgne overflader fra Farrow & Ball.",
                "Indvendigt er der arbejdet med specialfremstillede egetræssnedkerløsninger til både køkken og skabe, granitbordplader samt et fuldt integreret el-system, hvor store dele af huset styres digitalt via skærme.",
                "Kombinationen af materialer, proportioner og specialløsninger skaber et sommerhus med en rolig og eksklusiv atmosfære, hvor både funktionalitet og æstetik er tænkt ned i detaljen. Projektet understreger MM Byggeri & Rådgivnings tilgang til eksklusive boliger og sommerhuse, hvor håndværk, rådgivning og arkitektonisk forståelse går hånd i hånd gennem hele processen.",
            ],
            en: [
                "On Kystvej in Hornbæk, MM Byggeri & Rådgivning built a new 380 m² summer house as a general contract. The project sits on one of Denmark's most exclusive summer house roads and was created with an uncompromising focus on materials, detail and the overall experience of the house.",
                "Among other things, the project involved excavation for a full basement under demanding conditions where groundwater had to be continuously pumped out to establish the construction correctly.",
                "The house itself is built as a timber house and executed with a long list of exclusive material choices — Canadian red cedar shingles, copper details, natural stone floors, Italian tiles, oak floors in large herringbone, and custom-oiled surfaces. Windows and doors are supplied by Skjern Vinduer, while the house is also fitted with integrated sliding doors, custom wallpapers and hand-applied Farrow & Ball finishes.",
                "Inside, the work includes custom oak joinery for both kitchen and cabinetry, granite countertops and a fully integrated electrical system in which large parts of the house are controlled digitally via screens.",
                "The combination of materials, proportions and bespoke solutions creates a summer house with a calm and exclusive atmosphere where function and aesthetics are considered down to the last detail. The project underlines MM Byggeri & Rådgivning's approach to exclusive homes and summer houses — where craft, advice and architectural understanding go hand in hand throughout the process.",
            ],
        },
        gallery: [
            IMG.kystHall,
            IMG.droneExterior,
            IMG.kystDrone2,
            IMG.kystCedarCopper,
            IMG.copperDetail,
            IMG.kystCoffered,
            IMG.kystKitchenFull,
            IMG.kystKitchenMain,
            IMG.kystKitchenWide,
            IMG.kystKitchenHoodDetail,
            IMG.kystKitchenButler,
            IMG.kystWallpaper,
            IMG.kystCorridor,
            IMG.kyst2231,
            IMG.kyst2241,
            IMG.kyst2250,
            IMG.kyst2254,
            IMG.kyst2258,
            IMG.kystParquet,
            IMG.kystChevronFloor,
            IMG.kystMarbleShower2,
            IMG.kystBrassShower,
        ],
        materials: {
            da: [
                "Canadiske rødcederspån",
                "Kobberdetaljer",
                "Naturstensgulve",
                "Italienske fliser",
                "Egetræ i stor sildebensstav",
                "Skjern Vinduer",
                "Farrow & Ball overflader",
                "Granitbordplader",
            ],
            en: [
                "Canadian red cedar shingles",
                "Copper details",
                "Natural stone floors",
                "Italian tiles",
                "Oak in large herringbone",
                "Skjern Vinduer",
                "Farrow & Ball finishes",
                "Granite countertops",
            ],
        },
    },
];

export const team = [
    {
        name: "Martin Madsen",
        roleDa: "Stifter & Indehaver",
        roleEn: "Founder & Owner",
        bioDa: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod.",
        bioEn: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod.",
        portrait:
            "/images/founderPortrait",
    },
    {
        name: "Anders Lund",
        roleDa: "Projektleder",
        roleEn: "Project Manager",
        bioDa: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
        bioEn: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
        portrait:
            "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&q=80",
    },
    {
        name: "Sofie Krogh",
        roleDa: "Indretningsarkitekt",
        roleEn: "Interior Architect",
        bioDa: "Ut enim ad minim veniam quis nostrud exercitation.",
        bioEn: "Ut enim ad minim veniam quis nostrud exercitation.",
        portrait:
            "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80",
    },
    {
        name: "Niels Hoff",
        roleDa: "Medaljetømrer",
        roleEn: "Master Carpenter",
        bioDa: "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
        bioEn: "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
        portrait:
            "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
    },
    {
        name: "Mette Holm",
        roleDa: "Byggeleder",
        roleEn: "Construction Manager",
        bioDa: "Excepteur sint occaecat cupidatat non proident sunt in culpa.",
        bioEn: "Excepteur sint occaecat cupidatat non proident sunt in culpa.",
        portrait:
            "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&q=80",
    },
    {
        name: "Frederik Borg",
        roleDa: "Tømrer",
        roleEn: "Carpenter",
        bioDa: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        bioEn: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        portrait:
            "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600&q=80",
    },
];
